import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CheckItem } from './CheckItem';
type BonusCardProps = {
  number: string;
  title: string;
  highlight: string;
  text: string;
  includes: string[];
};
export function BonusCard({
  number,
  title,
  highlight,
  text,
  includes
}: BonusCardProps) {
  return <article className="rounded-md border-l-[5px] border-amber-400 bg-white px-3.5 py-3 text-left md:px-4 md:py-3.5" data-id="element-21" data-mp="2x508bn1nma1z">
      <h3 className="flex items-start gap-2 text-[14px] font-extrabold uppercase leading-tight text-blue-950 md:text-[15px]" data-id="element-22" data-mp="20fr3g1lis2v4">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-amber-600" strokeWidth={2.5} aria-hidden data-id="element-23" data-mp="25bgaepzvcm1g" />
        <span data-id="element-24" data-mp="29d1i7wxjqa4s">
          Bono {number} — {title}
        </span>
      </h3>
      <p className="mt-1.5 text-[14px] font-bold leading-snug text-teal-700 md:text-[15px]" data-id="element-25" data-mp="2e7fgq87i8xdo">{highlight}</p>
      <p className="mt-0.5 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-26" data-mp="1hnghbjf34jjp">{text}</p>
      <ul className="mt-1.5 grid gap-x-4 gap-y-0.5 text-[13px] leading-[1.4] text-slate-600 sm:grid-cols-3 md:text-[14px]" data-id="element-27" data-mp="1lo0hywyva5al">
        {includes.map(item => <CheckItem key={item} data-id="element-28" data-mp="1s2ib7k3tv1ia">{item}</CheckItem>)}
      </ul>
      <p className="mt-2 text-[12px] font-extrabold uppercase md:text-[13px]" data-id="element-29" data-mp="1s5e958fodq6q">
        <span className="text-slate-500" data-id="element-30" data-mp="1nagxruuxb4qo">40 páginas</span> <span className="text-slate-400" data-id="element-31" data-mp="1idqj9byroh7d">—</span>{' '}
        <span className="text-green-600" data-id="element-32" data-mp="1ib4dnhvfsbrs">Gratis</span>
      </p>
    </article>;
}